export default "__VITE_ASSET__DCf41i6c__"